import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { DocumentTitle } from './components/DocumentTitle';
import { AuthProvider } from './context/AuthContext';
import './styles/spark.css';
import './styles/app.css';
import './styles/cryptic.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DocumentTitle />
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
